import apiService from "../rest";
import CalculateCartDTO from "../data-transfer-objects/CalculateCartDTO";
import { OAPI_API_TYPE } from "@/utils";

export const getOAPIMappedModifiers = (modifiersMap) => {
  return Object.entries(modifiersMap).reduce((acc, [uuid, modifier]) => {
    acc[uuid] = {
      item: {
        id: String(modifier.modifierId),
        name: modifier.name,
        images: modifier.images,
        price_override: modifier.priceOverride,
        discountable: modifier.discountable,
        taxable: modifier.taxable,
        display_name: modifier.displayName
      },
      quantity: 1,
      activity: "ACTIVITY_PURCHASE",
      cart_item_cost: {
        original_total: modifier.cost,
        original_unit_cost: modifier.cost,
        total: modifier.cost,
        unit_cost: modifier.cost
      }
    };
    return acc;
  }, {});
};

const getOAPICartSelectedItems = async (venueId, vendorId, cart, rootGetters) => {
  if (!cart.items.length) return [];
  const ids = cart.items.map((i) => i.item.id).join(",");
  const result = await apiService.orderingFetchVendorMenuItemById(venueId, vendorId, ids);
  const items = ids.split(",").map((val) => result.data.item.find((value) => value.item.item.id === val));

  const cartItems = items.map((value, index) => {
    const selectedCartItem = cart.items[index];
    value.item.item.notes = selectedCartItem.item.notes;

    return {
      item: value.item,
      activePriceLevel: value.active_price_level,
      quantity: selectedCartItem.quantity,
      modifiers: getOAPIMappedModifiers(selectedCartItem.modifiers || {})
    };
  });

  return cartItems;
};

class CalculateCartService {
  static async get(getters, rootGetters, dispatch, payload, venueId, vendorId, promoCode) {
    try {
      if (rootGetters["venueSettings/APIType"] === OAPI_API_TYPE) {
        const cartItems = await getOAPICartSelectedItems(venueId, vendorId, payload.cart, rootGetters);
        const { data } = await apiService.orderingCalculateCartApi(
          CalculateCartDTO.toOAPI(payload, cartItems, promoCode, dispatch, rootGetters),
          venueId,
          vendorId
        );
        return CalculateCartDTO.fromOAPI(data, getters, dispatch);
      } else {
        // checks for generic user id, will get it if not currently logged in.
        if (!rootGetters["user/getMobileUserData"]?.id) {
          await dispatch("user/loginGuestUser", "", { root: true });
        }

        const userId = rootGetters["user/getMobileUserData"]?.id;

        if (!userId) return;
        const { data } = await apiService.applyPromoCode({ ...payload, userId }, userId);
        return data;
      }
    } catch (error) {
      return Promise.reject(error);
    }
  }
}

export default CalculateCartService;
